import { render, staticRenderFns } from "./Emp_new.vue?vue&type=template&id=38929047&scoped=true&"
import script from "./Emp_new.vue?vue&type=script&lang=js&"
export * from "./Emp_new.vue?vue&type=script&lang=js&"
import style0 from "./Emp_new.vue?vue&type=style&index=0&id=38929047&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38929047",
  null
  
)

export default component.exports